import reduceReducers from "reduce-reducers";
import { getApiReducer } from "redux-store/api-sagas/reducers";
import { updateById } from "redux-store/reducers";

import {
  EDIT_USER_SUCCESS,
  LOAD_USERS_FAILURE,
  LOAD_USERS_SUCCESS,
} from "./actions";

const apiUsersReducer = getApiReducer(LOAD_USERS_SUCCESS, LOAD_USERS_FAILURE);

function userEditReducer(state, action) {
  const { type, payload } = action;
  const { data: user } = payload || {};

  switch (type) {
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        byId: updateById(state.byId, user),
      };
    default:
      return state;
  }
}

const usersReducer = reduceReducers(apiUsersReducer, userEditReducer);

export { usersReducer, userEditReducer };
